module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "security-configuration"
  }, [_c('h1', [_vm._v("Security Configuration")]), _vm._v(" "), _c('div', {
    staticClass: "table actions-table"
  }, [_c('div', {
    staticClass: "table-heading"
  }, [_c('div', {
    staticClass: "table-cell actions-heading__cell"
  }, [_vm._v("Actions:")]), _vm._v(" "), _vm._l((_vm.roles), function(role) {
    return _c('div', {
      staticClass: "table-cell actions-heading__cell"
    }, [_vm._v(_vm._s(role.name))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "table-body"
  }, _vm._l((_vm.actions), function(action) {
    return _c('div', {
      staticClass: "table-row"
    }, [_c('div', {
      staticClass: "table-cell"
    }, [_vm._v(_vm._s(action.actionName))]), _vm._v(" "), _vm._l((_vm.roles), function(role) {
      return _c('div', {
        staticClass: "table-cell"
      }, [_c('label', [_c('input', {
        staticClass: "table-checkbox",
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": _vm.checkIdLength(action.actionId, role.id)
        },
        on: {
          "change": function($event) {
            return _vm.select(action.actionId, action.actionName, role.id)
          }
        }
      }), _vm._v("\n      \t\t\t\tDisable\n      \t\t\t")])])
    })], 2)
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fee1096","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Admin/SecurityConfiguration.vue
// module id = 907
// module chunks = 1